import parse from 'html-react-parser';
import axios from 'axios';
import { API_ENDPOINT, HEADER_TOKEN } from '../../../../constants/constants';
import { cleanO, saveAnswers } from '../../../../utilities/utility';
import { toast } from 'react-toastify';
import { useState } from 'react';

const QuestionOption = (props) => {
    const IN_PROGRESS = "In progress";
    const {
        on, config, socket, currentQn, setCurrentQn, num, question,
        oc, setCh, ma, setMa, name, linkCode, finishAction
    } = props;

    const optionsI = ["A", "B", "C", "D", "E", "F"];
    const isAnswered = question.status === 'attempted';
    const [clicked, setClicked] = useState(false);

    const isCorrect = () => {
        let ind = question.options.findIndex(o => o.isCorrect);
        return optionsI[ind] === on;
    };

    const saveResponse = () => {
        const toSave = {
            linkCode: linkCode,
            name: name,
            topic: question.topic,
            question_id: question.question_id,
            choice: on,
            choiceCorrect: isCorrect() ? 1 : 0,
            optionId: oc.optionId
        };

        axios.post(API_ENDPOINT + 'user/option-response', toSave).then(res => {
            let d = res.data;
            finishAction();
            if (!d.success) {
                toast.error("The assessment is already completed and your new submission is rejected");
                document.location.href = "/assessment/" + linkCode + "/answer-sheet/" + encodeURI(name);
            }
        });
    };

    const onClick = () => {
        if (clicked) return; // prevent multiple fires
        setClicked(true);

        if (!(config.showAnswer && isAnswered)) {
            setCh(on);

            let findQ = ma.findIndex(m => m.question_id === question.question_id);
            let obj = ma[findQ];
            obj.status = 'attempted';
            obj.response = on;
            obj.choiceCorrect = isCorrect();
            let rl = [...ma];
            setMa(rl);

            let allCorrect = rl.filter(r => r.choiceCorrect);
            let allAttempted = rl.filter(r => r.status === 'attempted');
            let dto = {
                name: name,
                linkCode: linkCode,
                status: IN_PROGRESS,
                score: allCorrect.length,
                numAttempted: allAttempted.length
            };

            socket.emit('goLive', dto);
            saveAnswers({ name: name, linkCode: linkCode, questions: ma });

            // if (!config.allowBack && currentQn < num) {
            //     setCurrentQn(prev => {
            //         return prev + 1;
            //     });
            // }

            saveResponse();
        }
    };

    const labelClass = () => {
        if (!isAnswered) return 'que_opt';

        if (config.showAnswer) {
            return isCorrect()
                ? 'que_opt answer'
                : (question.response === on ? 'que_opt wrong' : 'que_opt');
        } else {
            return question.response === on ? 'que_opt answer' : 'que_opt';
        }
    };

    return (
        <label className={`option ${labelClass()}`} onClick={onClick}>
            <input type="radio" name="question" value={on} />
            <span className="option-text">
                <strong className="circle">{on}</strong> {parse(cleanO(oc.option))}
            </span>
        </label>
    );
};

export default QuestionOption;
